import { z } from 'zod';
/** The default (and currently only) input key for process connections */ export const DEFAULT_INPUT_KEY = 'initial';
/**
 * Process Connection Schema
 * A directed connection from a terminal step of one process to an input of another.
 * Ports are derived at query time from recording steps, not stored.
 */ export const ProcessConnectionSchema = z.object({
    _id: z.string(),
    sourceProcessId: z.string(),
    sourceStepId: z.string(),
    sourceRuleId: z.string().optional(),
    targetProcessId: z.string(),
    targetInputKey: z.string(),
    createdAt: z.string().optional()
});

//# sourceMappingURL=process-connection.schema.js.map